import { render } from "./endpointsTable.vue?vue&type=template&id=2ad6385a"
import script from "./endpointsTable.vue?vue&type=script&lang=js"
export * from "./endpointsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__